import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useRef } from 'react'
import { useRouter } from 'next/router'
import { useReveals } from '@/components/motion/use-reveals'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    const router = useRouter()
    const rootRef = useRef<HTMLDivElement>(null)
    const pageKey = router.asPath.split('#')[0]

    useReveals(rootRef, pageKey)

    return (
        <div ref={rootRef} className='relative flex min-h-screen flex-col'>
            <main id='main' className='relative flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
